/*
 * Copyright (c) 2021 brightlamp
 */

const devices =
{
    '': 'Unknown',
    'x86_64': 'iPhone Simulator',
    'iPhone1,1': 'iPhone',
    'iPhone1,2': 'iPhone 3G',
    'iPhone2,1': 'iPhone 3GS',
    'iPhone3,1': 'iPhone 4',
    'iPhone3,2': 'iPhone 4',
    'iPhone3,3': 'iPhone 4',
    'iPhone4,1': 'iPhone 4S',
    'iPhone5,1': 'iPhone 5',
    'iPhone5,2': 'iPhone 5',
    'iPhone5,3': 'iPhone 5C',
    'iPhone5,4': 'iPhone 5C',
    'iPhone6,1': 'iPhone 5S',
    'iPhone6,2': 'iPhone 5S',
    'iPhone7,1': 'iPhone 6 Plus',
    'iPhone7,2': 'iPhone 6',
    'iPhone8,1': 'iPhone 6s',
    'iPhone8,2': 'iPhone 6s Plus',
    'iPhone8,4': 'iPhone SE',
    'iPhone9,1': 'iPhone 7',
    'iPhone9,2': 'iPhone 7 Plus',
    'iPhone9,3': 'iPhone 7',
    'iPhone9,4': 'iPhone 7 Plus',
    'iPhone10,1': 'iPhone 8',
    'iPhone10,2': 'iPhone 8 Plus',
    'iPhone10,3': 'iPhone X',
    'iPhone10,4': 'iPhone 8',
    'iPhone10,5': 'iPhone 8 Plus',
    'iPhone10,6': 'iPhone X',
    'iPhone11,2': 'iPhone XS',
    'iPhone11,4': 'iPhone XS Max',
    'iPhone11,6': 'iPhone XS Max',
    'iPhone11,8': 'iPhone XR',
    'iPhone12,1': 'iPhone 11',
    'iPhone12,3': 'iPhone 11 Pro',
    'iPhone12,5': 'iPhone 11 Pro Max',
    'iPhone12,8': 'iPhone SE 2nd Gen',
    'iPhone13,1': 'iPhone 12 Mini',
    'iPhone13,2': 'iPhone 12',
    'iPhone13,3': 'iPhone 12 Pro',
    'iPhone13,4': 'iPhone 12 Pro Max',
    'iPhone14,2': 'iPhone 13 Pro',
    'iPhone14,3': 'iPhone 13 Pro Max',
    'iPhone14,4': 'iPhone 13 Mini',
    'iPhone14,5': 'iPhone 13',
    'iPhone14,6': 'iPhone SE 3rd Gen',
    'iPhone14,7': 'iPhone 14',
    'iPhone14,8': 'iPhone 14 Plus',
    'iPhone15,2': 'iPhone 14 Pro',
    'iPhone15,3': 'iPhone 14 Pro Max',
    'iPhone15,4': 'iPhone 15',
    'iPhone15,5': 'iPhone 15 Plus',
    'iPhone16,1': 'iPhone 15 Pro',
    'iPhone16,2': 'iPhone 15 Pro Max',
    'iPad1,1': 'iPad',
    'iPad1,2': 'iPad 3G',
    'iPad2,1': '2nd Gen iPad',
    'iPad2,2': '2nd Gen iPad',
    'iPad2,3': '2nd Gen iPad',
    'iPad2,4': '2nd Gen iPad',
    'iPad3,1': '3rd Gen iPad',
    'iPad3,2': '3rd Gen iPad',
    'iPad3,3': '3rd Gen iPad',
    'iPad2,5': 'iPad mini',
    'iPad2,6': 'iPad mini',
    'iPad2,7': 'iPad mini',
    'iPad3,4': '4th Gen iPad',
    'iPad3,5': '4th Gen iPad',
    'iPad3,6': '4th Gen iPad',
    'iPad4,1': 'iPad Air',
    'iPad4,2': 'iPad Air',
    'iPad4,3': '1st Gen iPad Air',
    'iPad4,4': 'iPad mini Retina',
    'iPad4,5': 'iPad mini Retina',
    'iPad4,6': 'iPad mini Retina',
    'iPad4,7': 'iPad mini 3',
    'iPad4,8': 'iPad mini 3',
    'iPad4,9': 'iPad Mini 3',
    'iPad5,1': 'iPad mini 4',
    'iPad5,2': '4th Gen iPad mini',
    'iPad5,3': 'iPad Air 2',
    'iPad5,4': 'iPad Air 2',
    'iPad6,3': 'iPad Pro 9.7',
    'iPad6,4': 'iPad Pro 9.7',
    'iPad6,7': 'iPad Pro 12.9',
    'iPad6,8': 'iPad Pro 12.9',
    'iPad6,11': 'iPad 2017',
    'iPad6,12': 'iPad 2017',
    'iPad7,1': 'iPad Pro 2nd Gen',
    'iPad7,2': 'iPad Pro 2nd Gen',
    'iPad7,3': 'iPad Pro 10.5',
    'iPad7,4': 'iPad Pro 10.5',
    'iPad7,5': 'iPad 6th Gen',
    'iPad7,6': 'iPad 6th Gen',
    'iPad7,11': 'iPad 7th Gen 10.2',
    'iPad7,12': 'iPad 7th Gen 10.2',
    'iPad8,1': 'iPad Pro 3rd Gen 11',
    'iPad8,2': 'iPad Pro 3rd Gen 11',
    'iPad8,3': 'iPad Pro 3rd Gen 11',
    'iPad8,4': 'iPad Pro 3rd Gen 11',
    'iPad8,5': 'iPad Pro 3rd Gen 12.9',
    'iPad8,6': 'iPad Pro 3rd Gen 12.9',
    'iPad8,7': 'iPad Pro 3rd Gen 12.9',
    'iPad8,8': 'iPad Pro 3rd Gen 12.9',
    'iPad8,9': 'iPad Pro 2nd Gen 11',
    'iPad8,10': 'iPad Pro 2nd Gen 11',
    'iPad8,11': 'iPad Pro 4th Gen 12.9',
    'iPad8,12': 'iPad Pro 4th Gen 12.9',
    'iPad11,1': 'iPad mini 5th Gen',
    'iPad11,2': 'iPad mini 5th Gen',
    'iPad11,3': 'iPad Air 3rd Gen',
    'iPad11,4': 'iPad Air 3rd Gen',
    'iPad11,6': 'iPad 8th Gen 10.2',
    'iPad11,7': 'iPad 8th Gen 10.2',
    'iPad12,1': 'iPad 9th Gen 10.2',
    'iPad12,2': 'iPad 9th Gen 10.2',
    'iPad13,1': 'iPad Air 4th Gen',
    'iPad13,2': 'iPad Air 4th Gen',
    'iPad13,4': 'iPad Pro 3rd Gen 11',
    'iPad13,5': 'iPad Pro 3rd Gen 11',
    'iPad13,6': 'iPad Pro 3rd Gen 11',
    'iPad13,7': 'iPad Pro 3rd Gen 11',
    'iPad13,8': 'iPad Pro 5th Gen 12.9',
    'iPad13,9': 'iPad Pro 5th Gen 12.9',
    'iPad13,10': 'iPad Pro 5th Gen 12.9',
    'iPad13,11': 'iPad Pro 5th Gen 12.9',
    'iPad13,16': 'iPad Air 5th Gen',
    'iPad13,17': 'iPad Air 5th Gen',
    'iPad13,18': 'iPad 10th Gen',
    'iPad13,19': 'iPad 10th Gen',
    'iPad14,3': 'iPad Pro 11 inch 4th Gen',
    'iPad14,4': 'iPad Pro 11 inch 4th Gen',
    'iPad14,5': 'iPad Pro 12.9 inch 6th Gen',
    'iPad14,6': 'iPad Pro 12.9 inch 6th Gen',
    'iPad14,1': 'iPad mini 6th Gen',
    'iPad14,2': 'iPad mini 6th Gen',
    'iPod7,1': '6th Gen iPod',
    'iPod9,1': '7th Gen iPod'
};

function deviceCodeToString(code)
{
    return devices[code];
}

const jobs =
{
    0: 'N/A',
    1: 'Anesthesiologist',
    2: 'Athletic Trainer',
    3: 'Audiologist',
    4: 'EMT/Medic',
    5: 'General Practitioner',
    6: 'Neurologist',
    7: 'Neuroscientist',
    8: 'Neurosurgeon',
    9: 'Nurse',
    10: 'Nurse Practitioner',
    11: 'Ophthalmologist',
    12: 'Optometrist',
    13: 'Pediatrician',
    14: 'Physician Assistant',
    15: 'Psychiatrist/Psychologist',
    16: 'Sports Medicine Physician',
    17: 'Other',
    18: 'Chiropractor',
    19: 'Primary Care Optometrist',
    20: 'Specialty Optometrist'
};

function jobCodeToString(code)
{
    return jobs[code];
}

const uses =
{
    0: 'N/A',
    1: 'ADD/ADHD',
    2: 'Alzheimer\'s Disease',
    3: 'Anesthesiology',
    4: 'Audiology',
    5: 'Autism Spectrum Disorder',
    6: 'Behavior Modification',
    7: 'Brain Mass/Tumor',
    8: 'Central Desensitization',
    9: 'Cognitive Impairment',
    10: 'Concussion/mTBI',
    11: 'Critical Care',
    12: 'Diabetes',
    13: 'Diabetic Retinopathy',
    14: 'Emergency Medicine',
    15: 'Fatigue/Sleep Disorders',
    16: 'Geriatrics',
    17: 'Glaucoma',
    18: 'Heart Rate Variability',
    19: 'Increased Intracranial Pressure',
    20: 'Integrative Medicine',
    21: 'Intoxication',
    22: 'Linguistics',
    23: 'Opioids/Narcotics',
    24: 'Parkinson\'s Disease',
    25: 'Stress',
    26: 'Strokes',
    27: 'Vision Spectrum',
    28: 'Other'
};

function useCodeToString(code)
{
    return uses[code];
}

const sourceData =
{
    0: 'N/A',
    1: 'Conference',
    2: 'Internet/Online',
    3: 'Referral',
    4: 'Other',
    5: 'Social Media',
    6: 'Carrick Institute Referral',
    7: 'Website',
    8: 'Email/Newsletter',
    9: 'Continued Education Course',
    10: 'University Curriculum',
    11: 'Internet/Online',
    12: 'Blog/News Article',
    13: 'Reflex Contacted Me'
};

function sourceDataCodeToString(code)
{
    return sourceData[code];
}

export {devices, deviceCodeToString, jobs, jobCodeToString, uses, useCodeToString, sourceData, sourceDataCodeToString};